module.exports = __webpack_public_path__ + "static/media/home-layout-menu-two.cac3b86f.png";